// extracted by css-extract-rspack-plugin
export default {"wrapper":"hero-header-module__wrapper___DrVA2"};